import {Link} from "react-router-dom";

const DashboardTableItem = ({data}) => {
    return (
        <div className="col-md-6 mt-2">
            <div className="card">
                <div className="card-header">

                    <span><b>Factory :</b> <Link to="/EmployeeStatus">{data.factoryName}</Link></span>
                    <span className="float-end"><b>Total :</b> {data.totalUser}</span>

                </div>
                <div className="card-body">
                    <table className="table">
                        <thead>
                        <tr>
                            <th scope="col">Title</th>
                            <th scope="col" className="text-center">Completed</th>
                            <th scope="col" className="text-center">Remaining</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>Core Values</td>
                            <td className="text-center">{data.assesmentCompleted}</td>
                            <td className="text-center">{data.assesmentNotCompleted}</td>
                        </tr>
                        <tr>
                            <td>Core Competency</td>
                            <td className="text-center">{data.competencyCompleted}</td>
                            <td className="text-center">{data.competencyNotCompleted}</td>

                        </tr>
                        <tr>
                            <td>Skill Will Matrix</td>
                            <td className="text-center">{data.skillMatrixCompleted}</td>
                            <td className="text-center">{data.skillMatrixNotCompleted}</td>
                        </tr>
                        <tr>
                            <td>Planning</td>
                            <td className="text-center">{data.taskSubmitted}</td>
                            <td className="text-center">{data.taskNotSubmitted}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default DashboardTableItem